import React, { useState } from 'react';
import {
  Row,
  Col,
  Input,
  Typography,
  Button,
  Table,
  Space,
  Tag,
  Skeleton,
  Result
} from 'antd';
import {
  FaSearch,
} from "react-icons/fa"; //Font Awesome 5

import { useQuery } from '@tanstack/react-query';
import { formatPhone } from '../../utils/customFunctions';
import DeletePopupButton from './components/DeletePopupButton';
import CreateButton from '../../components/CreateButton';


const columns = [
  {
    title: 'name (ภาษาไทย)',
    dataIndex: 'fname_th',
    key: 'fname_th',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/users/edit/${record._id}`}
        style={{
          width: "100%",
          textAlign: 'left',
          background: 'none'
        }}>
        {text}
      </Button>
  },
  {
    title: 'lastname (ภาษาไทย)',
    dataIndex: 'lname_th',
    key: 'lname_th',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/users/edit/${record._id}`}
        style={{
          width: "100%",
          textAlign: 'left',
          background: 'none'
        }}>
        {text}
      </Button>
  },
  {
    title: 'phone',
    dataIndex: 'phone',
    key: 'phone',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/users/edit/${record._id}`}
        style={{
          width: "100%",
          textAlign: 'left',
          background: 'none'
        }}>
        {formatPhone(text)}
      </Button>
  },
  {
    title: 'position',
    dataIndex: 'role',
    key: 'role',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/users/edit/${record._id}`}
        style={{
          width: "100%",
          textAlign: 'left',
          background: 'none'
        }}>
        {text}
      </Button>
  },
  {
    title: 'status',
    dataIndex: 'is_active',
    align:'center',
    render: (_, record) => record.is_active ? <Tag color="green" style={{borderRadius:'20px'}}>Actived</Tag> : <Tag color="red" style={{borderRadius:'20px'}}>Inactive</Tag>
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <DeletePopupButton data={record} />
      </Space>
    ),
  }
]

function List() {
  const [filterData, setFilterData] = useState(null);
  const { isError, isLoading, data, error } = useQuery({
    queryKey: ['/api/users/'],
  })


  if (isLoading) {
    return <Skeleton active />
  }

  if (isError) {
    return <Result status="error" title={error.message} />
  };

  const onSearch = e => {
    const s = e.target.value;
    const target = data.filter(f => f.fname.includes(s) || f.lname.includes(s) || f.phone.includes(s))
    setFilterData(target);
  }

  // console.log('data =>', data);
  // console.log('search =>', search);
  return (
    <div>
      <Row gutter={[16, 16]} >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            {/* <FaUserTie style={{fontSize:'64px'}}/>  */}
            Users
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row justify='space-between' gutter={[16, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Input placeholder="Search" prefix={<FaSearch />} onChange={onSearch} />
            </Col>
            <Col xs={24} sm={12}>
              <Row justify='end'>
                <Col>
                  <CreateButton linkTo='/admin/users/create' />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={24}>
          <Table
            scroll={{
              x: 1200,
            }}
            rowKey={(record) => record._id}
            columns={columns}
            dataSource={filterData || data} />
        </Col>
      </Row>
    </div>
  )
}

export default List